module.exports = {
      id: "health-usage",
      viewBox: "0 0 26.46 26.46",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#health",
      toString: function () {
        return this.url;
      }
    }